<div class="row card-nominative-rds">
  <!-- Header con nombre de la fuente -->
  <div class="col-lg-12 mb-2">
    <div class="d-block">
      <div class="d-flex align-items-center">
        @if (sourceName) {
          <strong class="title-nominative-rds">{{ sourceName }}</strong>
        } @else {
          <strong class="title-nominative-rds text-muted">Cargando fuente RDS...</strong>
        }
      </div>
    </div>
  </div>

  <!-- Info de Primary Key y Alternate Keys -->
  @if (primaryKeyFields.length > 0 || alternateKeyFields.length > 0) {
    <div class="col-lg-12">
      <div class="d-flex justify-content-start nominative-rds-container flex-wrap">

        <!-- Primary Key -->
        @if (primaryKeyFields.length > 0) {
          <div class="info-block">
            <div class="d-block">
              <div class="nominative-rds-title">
                <span class="material-symbols-outlined icon-sm me-1">key</span>
                Primary Key
              </div>
              <div class="nominative-rds-description">
                <div class="pk-composition">
                  <span class="pk-field-combined">{{ primaryKeyComposed }}</span>
                </div>
                @if (primaryKeyFields.length > 1) {
                  <div class="pk-note">
                    <span class="text-muted">Separador: </span>
                    <code class="separator-badge">"{{ primaryKeySeparator }}"</code>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- Alternate Keys -->
        <div class="info-block">
          <div class="d-block">
            <div class="nominative-rds-title">
              <span class="material-symbols-outlined icon-sm me-1">vpn_key</span>
              Alternate Keys
            </div>
            <div class="nominative-rds-description">
              @if (alternateKeyFields.length > 0) {
                <div class="ak-list">
                  @for (key of alternateKeyFields; track key) {
                    <span class="ak-badge">{{ key }}</span>
                  }
                </div>
              } @else {
                <span class="text-muted">Sin alternate keys definidas</span>
              }
            </div>
          </div>
        </div>

      </div>
    </div>
  }
</div>

